import { RestaurantCard } from './RestaurantCard';

export default RestaurantCard;
